module.exports = __webpack_public_path__ + "static/media/logo-typo.726921ec.svg";